import axios from 'axios'
import { captureError } from './errorUtils'

export const resolveApiUrl = (path: string) => {
    const protocol = process.env.NEXT_PUBLIC_ROOT_DOMAIN?.includes('localhost') ? 'http' : 'https'
    return `${protocol}://${process.env.NEXT_PUBLIC_ROOT_DOMAIN}/api${path}`
}

export class HttpError extends Error {
    status: number
    code?: string
    details?: unknown

    constructor({
        status,
        code,
        message,
        details
    }: {
        status: number
        code?: string
        message: string
        details?: unknown
    }) {
        super(message)
        this.name = 'HttpError'
        this.status = status
        this.code = code
        this.details = details
    }
}

export function handleAxiosError(error: unknown): never {
    if (axios.isAxiosError(error)) {
        const status = error.response?.status || 500
        const data = error.response?.data
        const url = error.config?.url
        const method = error.config?.method?.toUpperCase()

        const httpError = new HttpError({
            status,
            code: data?.code,
            message: data?.message || 'Unexpected server error',
            details: data
        })

        captureError(httpError, {
            tags: {
                'error.type': 'http',
                'http.status': String(status),
                'http.method': method || 'UNKNOWN',
                ...(data?.code && { 'error.code': data.code })
            },
            extra: {
                request: { url, method, status },
                response: { code: data?.code, message: data?.message, details: data }
            },
            level: status >= 500 ? 'error' : 'warning'
        })

        throw httpError
    }

    const unknownError = new HttpError({
        status: 500,
        message: error instanceof Error ? error.message : 'Unknown error occurred'
    })

    captureError(unknownError, {
        tags: { 'error.type': 'unknown' }
    })

    throw unknownError
}
